export default "__VITE_ASSET__C8u8ey3x__"